const indexItems = [
  { icon: 'ri-fire-line', label: '动作大片', desc: '热血沸腾的视听盛宴', color: 'bg-accent-100 text-accent-700' },
  { icon: 'ri-emotion-laugh-line', label: '喜剧精选', desc: '欢乐不断笑料百出', color: 'bg-primary-100 text-primary-700' },
  { icon: 'ri-rocket-line', label: '科幻巨制', desc: '震撼视效脑洞大开', color: 'bg-secondary-100 text-secondary-700' },
  { icon: 'ri-search-eye-line', label: '悬疑推理', desc: '烧脑剧情层层反转', color: 'bg-accent-100 text-accent-700' },
  { icon: 'ri-heart-line', label: '爱情文艺', desc: '温情细腻触动心弦', color: 'bg-primary-100 text-primary-700' },
  { icon: 'ri-ghost-line', label: '恐怖惊悚', desc: '紧张刺激全程高能', color: 'bg-secondary-100 text-secondary-700' },
  { icon: 'ri-user-smile-line', label: '动漫世界', desc: '二次元精彩纷呈', color: 'bg-accent-100 text-accent-700' },
  { icon: 'ri-earth-line', label: '纪录纪实', desc: '真实世界深度探索', color: 'bg-primary-100 text-primary-700' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-3">
            专题合集
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            热门专题
          </h2>
          <p className="text-sm text-foreground-500 mt-3 max-w-lg mx-auto">
            按题材类型精心筛选，帮你快速找到想看的影片分类
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 md:gap-4">
          {indexItems.map((item) => (
            <a
              key={item.label}
              href="#cards"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="group flex flex-col items-center gap-3 p-5 md:p-6 rounded-xl bg-background-100 hover:bg-background-200 cursor-pointer transition-all duration-200"
            >
              <span className={`w-12 h-12 flex items-center justify-center rounded-xl ${item.color}`}>
                <i className={`${item.icon} text-xl`}></i>
              </span>
              <span className="text-sm font-semibold text-foreground-800 group-hover:text-primary-700 transition-colors whitespace-nowrap">
                {item.label}
              </span>
              <span className="text-xs text-foreground-400 text-center leading-relaxed">
                {item.desc}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}